import { render, staticRenderFns } from "./CuentaNuevaOrigen.vue?vue&type=template&id=776b594c&scoped=true"
import script from "./CuentaNuevaOrigen.vue?vue&type=script&lang=js"
export * from "./CuentaNuevaOrigen.vue?vue&type=script&lang=js"
import style0 from "./CuentaNuevaOrigen.vue?vue&type=style&index=0&id=776b594c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b594c",
  null
  
)

export default component.exports